/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ChangeEvent, useEffect, useState } from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Icon, IconButton, ImageList, ImageListItem, ImageListItemBar, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { VForm, useVForm } from '../../../shared/forms';
import InfoIcon from '@mui/icons-material/Info';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { PatrimoniosService } from '../../../shared/services/api/cadastros/PatrimoniosService';
import { Environment } from '../../../shared/environment';

interface IArquivo {
  Path: string;
  arquivo: File | undefined;
}

export interface ConfirmationDialogRawProps {
  id: string;
  value: string;
  open: boolean;
  onClose: (value?: string) => void;
  dados?: IArquivo[];
  onDados: (dados: IArquivo[]) => void;
}

export const DialogFiles: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {

  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const { formRef, save, } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState<File | undefined>();
  const [images, setImages] = useState<IArquivo[]>([]);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openConfirmItem, setOpenConfirmItem] = useState(false);

  const handleSave = () => {
    ///
  };

  type RowsType = IArquivo[];

  useEffect(() => {
    if (props.id === 'novo') {
      if (props.dados && typeof props.dados === 'object') {
        if (props.dados.length === 1) {
          setImages([]);
        }
      }
    } else {
      if (props.dados && typeof props.dados === 'object') {
        const list = props.dados.map((item) => ({ Path: item.Path, arquivo: undefined }));
        setImages(list);
      }
    }
  }, [open]);

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleCancel = () => {
    props.onDados(images);
    onClose();
  };

  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSelectedImage(event.target.files?.[0]);
    const imagen = event.target.files?.[0];
    if (imagen) {
      const imageUrl = URL.createObjectURL(imagen);
      const updatedList = [{ Path: imageUrl, arquivo: imagen }, ...images];
      setImages(updatedList);
    }
    if (props.id !== 'novo') {
      PatrimoniosService.updateByIdFiles(props.id, imagen)
        .then(result => {
          if (result instanceof Error) {
            alert(result.message);
          }
        });
    }
  };

  const handleDelete = (value: string) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm('Realmente deseja apagar a Imagem?')) {
      PatrimoniosService.deleteByIdFiles(props.id, value)
        .then(result => {
          if (result instanceof Error) {
            alert(result.message);
          } else {
            alert('Registro apagado com sucesso!');
            const filteredList = images.filter((item: any) => item.imgPath !== value);
            props.onDados(filteredList);
            onClose();
          }
        });
    }
  };

  return (
    <Dialog
      open={open}
      {...other}
    >
      <DialogTitle>Arquivos</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef} onSubmit={handleSave}>
          <Grid container direction="column" padding={1} >
            <Grid container item direction="row" padding={1} spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={1} >
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Documento</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {props.dados?.map(row => (
                            <TableRow key={row.Path}>
                              <TableCell>{row.Path}</TableCell>
                              <TableCell>
                                <IconButton disabled={isLoading} size="small" onClick={() => { window.open(Environment.URL_PDFPATRIMONIO + row.Path, '_blank');}}>
                                  <Icon>text_snippet</Icon>
                                </IconButton>
                              </TableCell>
                              <TableCell>
                                <IconButton disabled={isLoading} size="small" onClick={() => { handleDelete(row.Path); }}>
                                  <Icon>delete</Icon>
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </VForm>
      </DialogContent>
      <DialogActions>
        <ArrowBackIosIcon onClick={handleCancel} color='primary' sx={{ fontSize: 45 }} />
        <Box flex={1} display="flex" justifyContent="end" marginRight={5} >
          <input
            type="file"
            id="img-input"
            accept="file/*"
            style={{ display: 'none' }}
            onChange={handleImageChange}
          />
          <label htmlFor="img-input">
            <MenuBookIcon color='secondary' sx={{ fontSize: 45 }} />
          </label>
        </Box>
      </DialogActions>
    </Dialog>

  );
}; 